import Vue from 'vue'
import Router from 'vue-router'
import home from '../components/home'
import index from '../components/content/index'
import examStart from '../components/content/examStart'
import buySucess from '../components/content/buySucess'
import resPassword from '../components/content/resPassword'
import resSucess from '../components/content/resSucess'
import buyPro from '../components/content/buyPro'
import about from '../components/about/about'
import personSet from '../views/personSet/personSet'
import contactUs from '../views/public/ContactUs'
import error from '../views/public/Error'
import community from '../views/community/community'
//课程
import curriculum from '../views/curriculum/curriculum'
		import companyProfile from '../components/about/companyProfile'
		import Memorabilia from '../components/about/Memorabilia'
		import Recruitment from '../components/about/Recruitment'
		import ContactUs from '../components/about/contactUs'
		import MediaReport from '../components/about/MediaReport'

Vue.use(Router)

export default new Router({
  routes: [
    {
      path: '/home',
      component: home,
      children:[
        //首页
        {
          path:'index',
          component:index
        },
				//关于我们
				{
				  path:'about',
				  component:about,
					children:[
						//公司介绍
						{
							path:'companyProfile',
							component:companyProfile
						},
						// ,
							//大计事
						{
							path:'Memorabilia',
							component:Memorabilia
						},
							//公司招聘
						{
							path:'Recruitment',
							component:Recruitment
						},
							//媒体报道
						{
							path:'MediaReport',
							component:MediaReport
						},
							//联系我们
						{
							path:'ContactUs',
							component:ContactUs
						},
						 {
						  path:"/about",
						  redirect:"/about/companyProfile"
						},
					]
				},

				//设置界面
				{
				  path:'personSet',
				  component:personSet
				},
        //考试开始
        {
          path:'examStart',
          component:examStart
        },
        //购买成功
        {
          path:'buySucess',
          component:buySucess
        },
        //重置密码
        {
          path:'resPassword',
          component:resPassword
        },
        //修改密码成功
        {
          path:'resSucess',
          component:resSucess
        },
        //购买课程
        {
          path:'buyPro',
          component:buyPro
        },
				 //联系我们
				{
				  path:'contactUs',
				  component:contactUs
				},
				 //error
				{
				  path:'error',
				  component:error
				},
				 //MD社区精英
				{
				  path:'community',
				  component:community
				},
				 //课程
				{
				  path:'curriculum',
				  component:curriculum
				},














        {
          path:"/home",
          redirect:"/home/index"
        },
      ]
    },
    {
      path: '*',
      redirect : '/home'//匹配所有路径，进行路由重定向
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js